import { jsx as m } from "react/jsx-runtime";
import { d, ax as v } from "../../vendor-Dd6qj6gJ.js";
import { forwardRef as f } from "react";
import { getSpacingClasses as g } from "../../utils/getSpacingClasses/index.js";
import { omitStyleRenderProps as j } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index23.css';const q = "_level1_jp6cq_1", x = "_level2_jp6cq_6", h = "_level3_jp6cq_11", $ = "_level4_jp6cq_16", S = "_heading_jp6cq_21", l = {
  level1: q,
  level2: x,
  level3: h,
  level4: $,
  heading: S
}, y = f(
  ({ children: o, level: e = 2, mt: s, mr: t, mb: c, ml: n, m: r, ...a }, i) => {
    const p = c ?? 8 - e - 1, _ = d(
      l.heading,
      l[`level${String(e)}`],
      g({ m: r, mb: p, ml: n, mr: t, mt: s })
    );
    return /* @__PURE__ */ m(
      v,
      {
        ...j(a),
        slot: "title",
        ref: i,
        level: e,
        className: _,
        "data-component": "Heading",
        children: o
      }
    );
  }
);
export {
  y as Heading
};
